<template>

<div class="padded">
  <backhaul-table :site-id="siteId" :provider="false" :site-data="siteData" :sharer-id="sharerId" />
</div>

</template>

<script>

import BackhaulTable from '@/components/backhaul/BackhaulTable'

export default {
  props: {
    siteId: {
      type: Number,
      required: true
    },

    sharerId: {
      type: Number,
      required: true
    },

    siteData: {
      type: Object,
      default: null
    },

    editMode: {
      type: Boolean,
      default: false
    }

  },

  components: {
    BackhaulTable
  }

}

</script>
